import classNames from 'classnames'
import { TemporalEntityId } from 'entities-next/common'
import { FundingRound, Investment as InvestmentType } from 'entities-next/fundingRounds'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { FormViews } from 'utils-next/forms'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Theme } from '@mui/material'

import { AddNewInvestment, Investment } from './components'
import { useInvestmentHandlers } from './FundingRoundInvestmentForm.container'

export type FundingRoundInvestmentFormProps = ExtendableStyles &
  Testable & {
    data: FundingRound
    onUpdate: (data: InvestmentType[]) => Promise<any> | any
  }

export function FundingRoundInvestmentForm({
  className,
  data: { investments: initialInvestmentList = [], id: fundingRoundId },
  onUpdate,
  ...otherProps
}: FundingRoundInvestmentFormProps) {
  const {
    investmentList,
    handlers: { updateInvestment, deleteInvestment, createInvestment },
  } = useInvestmentHandlers({
    initialInvestmentList,
    handleUpdate: onUpdate,
    fundingRoundId,
  })
  const { classes } = useStyles()
  return (
    <div className={classNames(className, classes.investmentContainer)} {...otherProps}>
      {investmentList.map((investment, index) => {
        const initialView = investment.id === TemporalEntityId.new ? FormViews.edit : FormViews.view
        return (
          <Investment
            className={classes.investment}
            key={`investment-${investment.id}-${index}`}
            data={investment}
            initialView={initialView}
            onUpdate={updateInvestment}
            onDelete={() => deleteInvestment(investment)}
            editable
          />
        )
      })}

      <AddNewInvestment onCreate={createInvestment} />
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  investmentContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  investment: {
    marginBottom: spacing(2),
  },
}))
